module.exports = __webpack_public_path__ + "static/media/linuxIcon.ccde2abd.svg";